import TopBarProgress from 'react-topbar-progress-indicator';

TopBarProgress.config({
  barColors: {
    '0': '#7fc142',
    '1.0': '#009900',
  },
  shadowBlur: 5,
});
export default TopBarProgress;
